import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Notificationpreference } from '../model/notificationpreference';

@Injectable({
  providedIn: 'root'
})
export class OrgnotificationsettingService {

  constructor(private http:HttpClient) { }
  // /project/{projectId}/person/{personId}/notification/
        
   getNotificationPreferences(personId:string){
     const httpOptions = {
       headers: new HttpHeaders({
         'Content-Type': 'application/json'
       })
     }
     return this.http.get<Notificationpreference[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+"/person/"+personId.substr(0,36)+"/notification",httpOptions);
   }
   setNotificationPreferences(notificationpreference:Notificationpreference){
     //console.log('notf pref fro service', notificationpreference)
     const httpOptions = {
       headers: new HttpHeaders({
         'Content-Type': 'application/json'
       })
     }
     return this.http.put(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+"/person/"+notificationpreference.personId.substr(0,36)+"/notification/"+notificationpreference.preference,JSON.stringify(notificationpreference),httpOptions);
   }
}
